import * as m from 'motion/react-m'
import { Motion } from '@/lib/motion/lazy-motion'
import { cn } from '@/lib/utils'

type OverlayProps = {
  close: () => void
  background?: boolean
  z?: number
  className?: string
}

export default function Overlay({ close, background = false, z = 30, className }: OverlayProps) {
  return (
    <Motion>
      <m.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        onClick={close}
        className={cn(
          'fixed left-0 top-0 h-screen w-screen',
          background && 'bg-black/30',
          className,
        )}
        style={{ zIndex: z }}
      />
    </Motion>
  )
}
